import { render, staticRenderFns } from "./checklist copy.vue?vue&type=template&id=abfcb506&scoped=true&"
import script from "./checklist copy.vue?vue&type=script&lang=js&"
export * from "./checklist copy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abfcb506",
  null
  
)

export default component.exports